import { UnityContext } from "react-unity-webgl";
import { UNITY_REF } from "../../../constants/productConfiguratorConstants";

export const configuratorUnityContext = new UnityContext(UNITY_REF);